import "@preview-kit/ui/styles/globals.css"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import PreviewKitWidget from "./components/widget"
import { ShortcutProvider } from "./providers/shortcut-provider"
import { ThemeProvider } from "./providers/theme-provider"

// Create a client
const queryClient = new QueryClient()

function App() {
	return (
		<ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
			<ShortcutProvider>
				<>
					<QueryClientProvider client={queryClient}>
						<PreviewKitWidget />
					</QueryClientProvider>
				</>
			</ShortcutProvider>
		</ThemeProvider>
	)
}

export default App
